var exports = {
  "k": "xe533113f--bbaf12--container",
};

module.exports = exports;
